export function normalizeHtml(raw?: string) {
  if (!raw) return '';

  // 1) If the whole thing is a JSON string (e.g. starts and ends with quotes), parse it
  const t = raw.trim();
  if (t.startsWith('"') && t.endsWith('"')) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return JSON.parse(t);
    } catch {
      /* fall through */
      return raw;
    }
  }

  // 2) Otherwise, at least unescape \" -> "
  return raw.replace(/\\"/g, '"');
}

export function stripTemporaryTag(html: string) {
  // remove <temporary ...> and </temporary>
  return html.replace(/<\/?temporary[^>]*>/g, '');
}
